export const statusOptions  = translations => [
  { value: 'FULFILLED', label: translations.done},
  { value: 'UNFULFILLED', label: translations.notDone},
  { value: 'NOT_RELEVANT', label: translations.notRelevant},
]

export const statusOptionsWithStarted  = translations => [
  { value: 'FULFILLED', label: translations.done},
  { value: 'UNFULFILLED', label: translations.notDone},
  { value: 'HALF_FULFILLED', label: translations.started},
  { value: 'NOT_RELEVANT', label: translations.notRelevant},
]

export const filterFields = (translations, gt) => [
  { name: 'statusTitle', label: translations.status, type: 'title' },
  { name: 'awaitingEquipment', label: gt.awaitingEquipment, type: 'select' },
  { name: 'equipmentReceivedWithDocumentation', label: gt.equipmentReceivedWithDocumentation, type: 'select' },
  { name: 'jobReleased', label: gt.jobReleased, type: 'select' },
  { name: 'productEvaluation', label: gt.productEvaluation, type: 'select' },
  { name: 'strippedAndDecontaminated', label: gt.strippedAndDecontaminated, type: 'select' },
  { name: 'builtAndTested', label: gt.builtAndTested, type: 'select' },
  { name: 'shipped', label: gt.shipped, type: 'select' },
  { name: 'technicalAndCommercialDecision', label: gt.technicalAndCommercialDecision, type: 'select' },
  { name: 'finalReportReleased', label: gt.finalReportReleased, type: 'select' },
  { name: 'closed', label: gt.closed, type: 'select' },
  { name: 'productInvestigation', label: gt.productInvestigation, type: 'select' },
  { name: 'customerHold', label: gt.customerHold, type: 'select' },
  { name: 'failureAnalysisEngineerNotAssigned', label: translations.failureAnalysisEngineerNotAssigned, type: 'switch' },
  { name: 'pendingMyApproval', label: translations.pendingMyApproval, type: 'switch' },
  { name: 'notificationNumber', label: translations.notificationNumber, type: 'input' },
  { name: 'serviceOrderNumber', label: translations.serviceOrderNumber, type: 'input' },
  { name: 'customerNumber', label: translations.customerNumber, type: 'input' },
  { name: 'customerName', label: translations.customerName, type: 'input' },
  { name: 'serviceProductNumber', label: translations.serviceProductNumber, type: 'input' },
  { name: 'materialNumber', label: translations.materialNumber, type: 'input' },
  { name: 'equipmentSerialNumber', label: translations.equipmentSerialNumber, type: 'input' },
];

export const multiSelectFilterFields= [
  { name: 'serviceTechnologyCenterPlannerGroup', label: 'STC planner group' },
  { name: 'customerCenterPlantCode', label: 'Customer center plant code' },
  { name: 'distributorCode', label: 'Distributor' },
]



// WEBPACK FOOTER //
// ./src/components/FilterJobs/constants.js